// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep.myCustomModalClassInterfaceCompare.modal.show {
  z-index: 1050 !important;
  height: 100vh;
  width: 102vw;
  left: -1.3%;
  top: 3%;
}

::ng-deep.myCustomModalClassInterfaceCompare .modal-dialog {
  max-width: 97%;
  max-height: 94%;
  height: 94%;
  margin: auto;
  padding: 0 !important;
}

.interface-compare-modal {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.interface-compare-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #dee2e6;
  flex-shrink: 0;
}

.interface-compare-header__label {
  font-weight: 600;
  font-size: 15px;
  display: block;
  margin-bottom: 6px;
}

.interface-compare-header__pipeline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 99%;
  margin-left: 1%;
}

.interface-compare-pill {
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 13px;
  max-width: 42vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.interface-compare-pill--left {
  background-color: #fde8e8;
  color: #8b1a1a;
}

.interface-compare-pill--right {
  background-color: #e8f4fd;
  color: #0d5a7a;
  float: right;
}

.interface-compare-header__vs {
  font-weight: 600;
  color: #666;
  font-size: 12px;
}

.interface-compare-close {
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.6;
}

.interface-compare-close:hover {
  opacity: 1;
}

.interface-compare-body {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 16px 16px;
  height: 83vh !important;
}

.compare-summary-row {
  margin-bottom: 14px;
}

.compare-interface-card {
  border: 1px solid #d0d7de;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fafafa;
  font-size: 13px;
}

.compare-interface-card--active {
  border-left: 4px solid #07a36e;
}

.compare-interface-card--inactive {
  border-left: 4px solid #da606c;
}

.compare-interface-card__row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #eee;
}

.compare-interface-card__row:last-child {
  border-bottom: none;
}

.compare-interface-card__label {
  flex: 0 0 118px;
  font-weight: 600;
  color: #007887;
  white-space: nowrap;
}

.compare-interface-card__label::after {
  content: ":";
}

.compare-interface-card__value {
  flex: 1;
  min-width: 0;
  color: #333;
  font-weight: 500;
}

.compare-section {
  border: 1px solid #d0d7de;
  border-radius: 6px;
  margin-bottom: 12px;
  overflow: hidden;
}

.compare-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 8px 2px 14px;
  background: #129ab3;
  color: #fff;
  border: none;
  text-align: left;
}

.compare-section__header:hover {
  background: #0f8499;
}

.compare-section__header--toggle-only {
  width: 100%;
  cursor: pointer;
}

.compare-section__toggle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  border: none;
  color: #fff;
  flex: 1;
  min-width: 0;
  text-align: left;
  padding: 0;
  cursor: pointer;
}

.compare-section__header-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-left: 10px;
}

.compare-section__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.compare-section__chevron-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #fff;
  padding: 0;
  cursor: pointer;
  line-height: 1;
}

.compare-action-btn {
  border: 1px solid rgba(255, 255, 255, 0.65);
  color: #fff;
  background: transparent;
  min-width: 54px;
  font-size: 12px;
  line-height: 1.2;
}

.compare-action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.14);
}

.compare-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.compare-action-btn--save {
  border-color: #d3ffe1;
}

.compare-action-btn--cancel {
  border-color: #ffd6d6;
}

.compare-section__title {
  font-weight: 600;
  font-size: 14px;
}

.compare-section__title--with-help {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.compare-lookups-help-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #fff;
  opacity: 0.9;
  cursor: help;
  vertical-align: middle;
}
.compare-lookups-help-icon:hover {
  opacity: 1;
}

.compare-section__chevron {
  color: #fff;
}

.compare-section__body {
  padding: 10px;
  background: #fafafa;
}

.compare-section__lock-note {
  margin-bottom: 8px;
  color: #8a5300;
  background: #fff2d9;
  border: 1px solid #f7d8a2;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 12px;
}

.compare-section__status,
.compare-section__error {
  padding: 24px;
  text-align: center;
  font-size: 14px;
}

.compare-section__error {
  color: #c62828;
  font-weight: 600;
}

.compare-diff-wrap {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

::ng-deep .compare-diff-editor {
  width: 100%;
  height: 100%;
}

.compare-lookups-panel__title {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
  color: #007887;
}

.compare-lookups-table-wrap {
  max-height: 320px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.compare-lookups-table {
  width: 100%;
  table-layout: fixed;
  margin-bottom: 0;
}

.compare-lookups-table thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.compare-lookups-table tbody {
  display: block;
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}

.compare-lookups-table thead tr,
.compare-lookups-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.compare-lookups-col {
  flex: 1 1 0;
  min-width: 0;
}

.compare-lookups-arrows {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  align-self: center;
  min-height: 200px;
}

.compare-lookups-clear-btn {
  min-width: 56px;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 1.3;
  border: 1px solid #8a5300;
  background: #fff;
  color: #8a5300;
  border-radius: 4px;
}
.compare-lookups-clear-btn:hover {
  background: #fff2d9;
}

.compare-lookups-arrow-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #129ab3;
  background: #fff;
  color: #129ab3;
  border-radius: 4px;
}
.compare-lookups-arrow-btn:hover:not(:disabled) {
  background: #129ab3;
  color: #fff;
}
.compare-lookups-arrow-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.compare-lookups-arrow-btn mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}

.compare-lookups-table__check {
  width: 40px !important;
  max-width: 40px;
  padding: 4px 6px !important;
  text-align: center;
  vertical-align: middle;
}

.compare-lookups-table thead th:not(.compare-lookups-table__check) {
  width: calc((100% - 40px) / 3);
}

.compare-lookups-table td:not(.compare-lookups-table__check) {
  width: calc((100% - 40px) / 3);
}

.compare-lookups-table thead th {
  background: #129ab3;
  color: #fff;
  font-size: 12px;
  padding: 5px 8px;
}

.compare-lookups-table td {
  font-size: 12px;
  word-break: break-word;
  padding: 5px 8px;
  vertical-align: middle;
}

.compare-lookups-table__row--diff {
  background-color: #fde8e8;
}

.compare-lookups-table__row--selected {
  background-color: #d6eef3;
}

::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox .mdc-checkbox {
  width: 18px;
  height: 18px;
}
::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background {
  border-color: #129ab3;
  background-color: #129ab3;
}
::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:focus:checked ~ .mdc-checkbox__background {
  border-color: #129ab3;
  background-color: #129ab3;
}
::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: #fff;
}
::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox .mdc-checkbox__background {
  width: 18px !important;
  height: 18px !important;
}

.compare-lookups-preview {
  margin-bottom: 10px;
  border: 1px solid #129ab3;
  border-radius: 4px;
  background: #f4fbfd;
  padding: 10px 12px;
}

.compare-lookups-preview__header {
  font-weight: 600;
  font-size: 13px;
  color: #007887;
  margin-bottom: 8px;
}

.compare-lookups-preview__body {
  max-height: 160px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.compare-lookups-preview__pair {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 12px;
  padding: 3px 0;
  flex-wrap: wrap;
}

.compare-lookups-preview__index {
  color: #666;
  min-width: 18px;
}

.compare-lookups-preview__source,
.compare-lookups-preview__target {
  max-width: 42%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.compare-lookups-preview__arrow {
  color: #129ab3;
  font-weight: 600;
}

.compare-lookups-preview__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.compare-lookups-preview__confirm {
  background: #129ab3;
  border-color: #129ab3;
  color: #fff;
}
.compare-lookups-preview__confirm:hover {
  background: #0f8499;
  border-color: #0f8499;
  color: #fff;
}

::ng-deep .compare-lookups-help-tooltip {
  white-space: pre-line !important;
  max-width: 360px !important;
  font-size: 12px !important;
  line-height: 1.4 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/interface-compare/interface-compare.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,6BAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,2CAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,WAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AADF;AAGE;EACE,mBAAA;EACA,WAAA;AADJ;AAIE;EACE,YAAA;EACA,mBAAA;AAFJ;AAKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAHJ;;AAOA;EACE,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAQE;EACE,WAAA;EACA,YAAA;AALJ;AAOI;;EAEE,qBAAA;EACA,yBAAA;AALN;AAQI;EACE,qBAAA;EACA,yBAAA;AANN;AASI;EACE,WAAA;AAPN;AAWE;EACE,sBAAA;EACA,uBAAA;AATJ;;AAaA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAVF;;AAaA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAVF;;AAaA;EACE,WAAA;EACA,eAAA;AAVF;;AAaA;;EAEE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,cAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAVF;;AAaA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAVF;AAYE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAVJ;;AAcA;EACE,gCAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;AAXF","sourcesContent":["::ng-deep.myCustomModalClassInterfaceCompare.modal.show {\r\n  z-index: 1050 !important;\r\n  height: 100vh;\r\n  width: 102vw;\r\n  left: -1.3%;\r\n  top: 3%;\r\n}\r\n\r\n::ng-deep.myCustomModalClassInterfaceCompare .modal-dialog {\r\n  max-width: 97%;\r\n  max-height: 94%;\r\n  height: 94%;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n}\r\n\r\n.interface-compare-modal {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.interface-compare-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  padding: 10px 16px;\r\n  border-bottom: 1px solid #dee2e6;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.interface-compare-header__label {\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  display: block;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.interface-compare-header__pipeline {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  width: 99%;\r\n  margin-left: 1%;\r\n}\r\n\r\n.interface-compare-pill {\r\n  border-radius: 12px;\r\n  padding: 3px 10px;\r\n  font-size: 13px;\r\n  max-width: 42vw;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.interface-compare-pill--left {\r\n  background-color: #fde8e8;\r\n  color: #8b1a1a;\r\n}\r\n\r\n.interface-compare-pill--right {\r\n  background-color: #e8f4fd;\r\n  color: #0d5a7a;\r\n  float: right;\r\n}\r\n\r\n.interface-compare-header__vs {\r\n  font-weight: 600;\r\n  color: #666;\r\n  font-size: 12px;\r\n}\r\n\r\n.interface-compare-close {\r\n  font-size: 28px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  opacity: 0.6;\r\n}\r\n\r\n.interface-compare-close:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.interface-compare-body {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 12px 16px 16px;\r\n  height: 83vh !important;\r\n}\r\n\r\n.compare-summary-row {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.compare-interface-card {\r\n  border: 1px solid #d0d7de;\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n  background: #fafafa;\r\n  font-size: 13px;\r\n}\r\n\r\n.compare-interface-card--active {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n\r\n.compare-interface-card--inactive {\r\n  border-left: 4px solid #da606c;\r\n}\r\n\r\n.compare-interface-card__row {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  padding: 4px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.compare-interface-card__row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.compare-interface-card__label {\r\n  flex: 0 0 118px;\r\n  font-weight: 600;\r\n  color: #007887;\r\n  white-space: nowrap;\r\n}\r\n\r\n.compare-interface-card__label::after {\r\n  content: ':';\r\n}\r\n\r\n.compare-interface-card__value {\r\n  flex: 1;\r\n  min-width: 0;\r\n  color: #333;\r\n  font-weight: 500;\r\n}\r\n\r\n.compare-section {\r\n  border: 1px solid #d0d7de;\r\n  border-radius: 6px;\r\n  margin-bottom: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.compare-section__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 2px 8px 2px 14px;\r\n  background: #129ab3;\r\n  color: #fff;\r\n  border: none;\r\n  text-align: left;\r\n}\r\n\r\n.compare-section__header:hover {\r\n  background: #0f8499;\r\n}\r\n\r\n.compare-section__header--toggle-only {\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.compare-section__toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  background: transparent;\r\n  border: none;\r\n  color: #fff;\r\n  flex: 1;\r\n  min-width: 0;\r\n  text-align: left;\r\n  padding: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.compare-section__header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  margin-left: 10px;\r\n}\r\n\r\n.compare-section__actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.compare-section__chevron-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: transparent;\r\n  border: none;\r\n  color: #fff;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n}\r\n\r\n.compare-action-btn {\r\n  border: 1px solid rgba(255, 255, 255, 0.65);\r\n  color: #fff;\r\n  background: transparent;\r\n  min-width: 54px;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.compare-action-btn:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.14);\r\n}\r\n\r\n.compare-action-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.compare-action-btn--save {\r\n  border-color: #d3ffe1;\r\n}\r\n\r\n.compare-action-btn--cancel {\r\n  border-color: #ffd6d6;\r\n}\r\n\r\n.compare-section__title {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.compare-section__title--with-help {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.compare-lookups-help-icon {\r\n  font-size: 16px;\r\n  width: 16px;\r\n  height: 16px;\r\n  line-height: 16px;\r\n  color: #fff;\r\n  opacity: 0.9;\r\n  cursor: help;\r\n  vertical-align: middle;\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.compare-section__chevron {\r\n  color: #fff;\r\n}\r\n\r\n.compare-section__body {\r\n  padding: 10px;\r\n  background: #fafafa;\r\n}\r\n\r\n.compare-section__lock-note {\r\n  margin-bottom: 8px;\r\n  color: #8a5300;\r\n  background: #fff2d9;\r\n  border: 1px solid #f7d8a2;\r\n  border-radius: 4px;\r\n  padding: 6px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.compare-section__status,\r\n.compare-section__error {\r\n  padding: 24px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.compare-section__error {\r\n  color: #c62828;\r\n  font-weight: 600;\r\n}\r\n\r\n.compare-diff-wrap {\r\n  width: 100%;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n::ng-deep .compare-diff-editor {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.compare-lookups-panel__title {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  margin-bottom: 6px;\r\n  color: #007887;\r\n}\r\n\r\n.compare-lookups-table-wrap {\r\n  max-height: 320px;\r\n  overflow: hidden;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n}\r\n\r\n.compare-lookups-table {\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.compare-lookups-table thead {\r\n  display: table;\r\n  width: 100%;\r\n  table-layout: fixed;\r\n}\r\n\r\n.compare-lookups-table tbody {\r\n  display: block;\r\n  max-height: calc(320px - 40px);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  width: 100%;\r\n}\r\n\r\n.compare-lookups-table thead tr,\r\n.compare-lookups-table tbody tr {\r\n  display: table;\r\n  width: 100%;\r\n  table-layout: fixed;\r\n}\r\n\r\n.compare-lookups-col {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n}\r\n\r\n.compare-lookups-arrows {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  align-self: center;\r\n  min-height: 200px;\r\n}\r\n\r\n.compare-lookups-clear-btn {\r\n  min-width: 56px;\r\n  padding: 2px 8px;\r\n  font-size: 11px;\r\n  line-height: 1.3;\r\n  border: 1px solid #8a5300;\r\n  background: #fff;\r\n  color: #8a5300;\r\n  border-radius: 4px;\r\n\r\n  &:hover {\r\n    background: #fff2d9;\r\n  }\r\n}\r\n\r\n.compare-lookups-arrow-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 0;\r\n  border: 1px solid #129ab3;\r\n  background: #fff;\r\n  color: #129ab3;\r\n  border-radius: 4px;\r\n\r\n  &:hover:not(:disabled) {\r\n    background: #129ab3;\r\n    color: #fff;\r\n  }\r\n\r\n  &:disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n  mat-icon {\r\n    font-size: 22px;\r\n    width: 22px;\r\n    height: 22px;\r\n  }\r\n}\r\n\r\n.compare-lookups-table__check {\r\n  width: 40px !important;\r\n  max-width: 40px;\r\n  padding: 4px 6px !important;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.compare-lookups-table thead th:not(.compare-lookups-table__check) {\r\n  width: calc((100% - 40px) / 3);\r\n}\r\n\r\n.compare-lookups-table td:not(.compare-lookups-table__check) {\r\n  width: calc((100% - 40px) / 3);\r\n}\r\n\r\n.compare-lookups-table thead th {\r\n  background: #129ab3;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  padding: 5px 8px;\r\n}\r\n\r\n.compare-lookups-table td {\r\n  font-size: 12px;\r\n  word-break: break-word;\r\n  padding: 5px 8px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.compare-lookups-table__row--diff {\r\n  background-color: #fde8e8;\r\n}\r\n\r\n.compare-lookups-table__row--selected {\r\n  background-color: #d6eef3;\r\n}\r\n\r\n::ng-deep .compare-lookups-checkbox.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 18px;\r\n    height: 18px;\r\n\r\n    .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,\r\n    .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background {\r\n      border-color: #129ab3;\r\n      background-color: #129ab3;\r\n    }\r\n\r\n    .mdc-checkbox__native-control:enabled:focus:checked ~ .mdc-checkbox__background {\r\n      border-color: #129ab3;\r\n      background-color: #129ab3;\r\n    }\r\n\r\n    .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  .mdc-checkbox__background {\r\n    width: 18px !important;\r\n    height: 18px !important;\r\n  }\r\n}\r\n\r\n.compare-lookups-preview {\r\n  margin-bottom: 10px;\r\n  border: 1px solid #129ab3;\r\n  border-radius: 4px;\r\n  background: #f4fbfd;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.compare-lookups-preview__header {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  color: #007887;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.compare-lookups-preview__body {\r\n  max-height: 160px;\r\n  overflow-y: auto;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.compare-lookups-preview__pair {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  padding: 3px 0;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.compare-lookups-preview__index {\r\n  color: #666;\r\n  min-width: 18px;\r\n}\r\n\r\n.compare-lookups-preview__source,\r\n.compare-lookups-preview__target {\r\n  max-width: 42%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.compare-lookups-preview__arrow {\r\n  color: #129ab3;\r\n  font-weight: 600;\r\n}\r\n\r\n.compare-lookups-preview__actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n\r\n.compare-lookups-preview__confirm {\r\n  background: #129ab3;\r\n  border-color: #129ab3;\r\n  color: #fff;\r\n\r\n  &:hover {\r\n    background: #0f8499;\r\n    border-color: #0f8499;\r\n    color: #fff;\r\n  }\r\n}\r\n\r\n::ng-deep .compare-lookups-help-tooltip {\r\n  white-space: pre-line !important;\r\n  max-width: 360px !important;\r\n  font-size: 12px !important;\r\n  line-height: 1.4 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
